const dates = {
  analytics: {
    day: 'numeric',
    month: 'long',
  },
  achievementPreview: {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  },
  achievementCard: {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  deadline: {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  autoEndedShifts: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
  shiftsCalendar: {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  },
};

export const formats = {
  dates,
};



// WEBPACK FOOTER //
// ./src/_shared/constants/formats.js